import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_134_1702)",
		children: /* @__PURE__ */ _jsx("path", { d: "M12.6708 2.21744L21.1708 6.96744C21.679 7.22153 22 7.74092 22 8.30908V9.75006C22 10.4404 21.4404 11.0001 20.75 11.0001H20V19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H4V11.0001H3.25C2.55964 11.0001 2 10.4404 2 9.75006V8.30908C2 7.78827 2.26974 7.30843 2.70611 7.03636L11.3292 2.21744C11.7515 2.0063 12.2485 2.0063 12.6708 2.21744ZM18 11.0001H6V19H9V13H11V19H13V13H15V19H18V11.0001ZM12 4.1181L4 8.6181V9.00006H20V8.6181L12 4.1181ZM12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_134_1702",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBankLine;
